import { CONST } from '../../../const/const'
import { EventModel } from '../../../models/events/event.model'
import FirestoreService from '../../firestoreService'
import IEventService from './types'

// Constants
const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
/**
 * @info Event service
 */
class EventService {
  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  /**
   * @info Fetches the doc from the db
   * @param {IEventService["IGetRequest"]} req
   */
  get: IEventService['IGet'] = async (req: IEventService['IGetRequest']) => {
    const documentSnapshot = await FirestoreService.getItem(COLLECTIONS.EVENTS.NAME, req.docId)

    if (!documentSnapshot.exists())
      throw new Error(`Event doc where id: ${req.docId} does not exist`)

    const event = EventModel.fromFirestoreDoc(documentSnapshot).toObject()

    return {
      event,
    }
  }

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  /**
   * @info Fetches the doc from the db
   * @param {IEventService["ICreateRequest"]} req
   */
  create: IEventService['ICreate'] = async (req: IEventService['ICreateRequest']) => {
    const docToCreate = new EventModel(req.data).toFirestore()

    if (req.id) {
      await FirestoreService.createItemWithCustomId(COLLECTIONS.EVENTS.NAME, req.id, docToCreate)
      return {
        docId: req.id,
        event: {
          id: req.id,
          docToCreate,
        },
      }
    } else {
      const documentSnapshot = await FirestoreService.createItem(
        COLLECTIONS.EVENTS.NAME,
        docToCreate
      )
      return {
        docId: documentSnapshot.id,
        event: docToCreate,
      }
    }
  }

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  /**
   * @info Fetches the doc from the db
   * @param {IEventService["IUpdateRequest"]} req
   */
  update: IEventService['IUpdate'] = async (req: IEventService['IUpdateRequest']) => {
    let event = await this.get({
      docId: req.docId,
    })

    await FirestoreService.updateItem(
      COLLECTIONS.EVENTS.NAME,
      req.docId,
      new EventModel({
        ...event,
        ...req.fieldsToUpdate,
      }).toFirestore()
    )

    return {
      docId: req.docId,
      updatedFields: req.fieldsToUpdate,
    }
  }

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  /**
   * @info Fetches the doc from the db
   * @param {IEventService["IDeleteRequest"]} req
   */
  delete: IEventService['IDelete'] = async (req: IEventService['IDeleteRequest']) => {
    await FirestoreService.deleteItem(COLLECTIONS.EVENTS.NAME, req.docId)

    return true
  }
}

const EventService_ = new EventService()

export default EventService_
